export class CollectionScrollPosition {
  constructor () {
    // Last clicked item data
    this.lastClickedItemHrefKey = 'collectionScrollPosition-lastClickedItemHref'
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    )

    // Last visited url data
    this.lastVisitedUrlsKey =
      'collectionScrollPosition-lastVisitedCollectionUrl'
    this.lastVisitedUrls = sessionStorage.getItem(this.lastVisitedUrlsKey)

    this.currentUrl = this.urlToPathName(window.location.href)

    this.init()
  }

  init () {
    if (this.currentUrl.includes('/collections/')) {
      this.handleCollectionTemplate()
    } else if (this.currentUrl.includes('/products/')) {
      this.handleProductTemplate()
    } else {
      this.clearData()
    }
  }

  handleCollectionTemplate () {
    this.checkLastVisitedUrls(this.currentUrl)

    // Disable browser's native scrollRestoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    if (this.lastVisitedCollectionUrl === this.currentUrl) {
      this.clearData()
    }

    this.restoreScrollPosition()
    this.captureClickedItemHref()
  }

  handleProductTemplate () {
    this.checkLastVisitedUrls(this.currentUrl)

    if (!this.lastClickedItemHref) return

    // Check to see if current URL matches last clicked item's href value
    // If not, user has navigated away and scroll position data is reset
    if (this.lastClickedItemHref !== this.currentUrl) {
      this.clearData()
    }
  }

  restoreScrollPosition () {
    // Retrieve and restore last position
    if (!this.lastClickedItemHref) return

    const elementSelector = `a[href*="${this.lastClickedItemHref}"]`

    const attemptToScrollIntoView = () => {
      const element = document.querySelector(elementSelector)
      if (!element) return
      element.scrollIntoView({
        behavior: 'instant',
        block: 'center',
        inline: 'center',
      })
      document.removeEventListener(
        'collectionRendered',
        attemptToScrollIntoView,
      )
    }

    // Attempt on page load
    attemptToScrollIntoView()

    // Attempt once collection has been fully rendered
    document.addEventListener('collectionRendered', attemptToScrollIntoView)
  }

  captureClickedItemHref () {
    let clickedHref = null

    window.addEventListener('click', e => {
      const listItem = e.target.closest('.prd-List_Item')
      if (!listItem) return

      const getLink = listItem.querySelector('a[data-product-card-el="link"]')
      if (!getLink) return

      clickedHref = getLink.getAttribute('href')?.split('?')[0]
      if (clickedHref) {
        this.lastClickedItemHref = clickedHref
        sessionStorage.setItem(this.lastClickedItemHrefKey, clickedHref)
      }
    })

    window.addEventListener('beforeunload', () => {
      if (clickedHref) {
        sessionStorage.setItem(this.lastClickedItemHrefKey, clickedHref)
      }
    })
  }

  checkLastVisitedUrls (url) {
    const array = this.lastVisitedUrls
      ? [...JSON.parse(this.lastVisitedUrls)]
      : []
    array.push(url)
    if (array[array.length - 1] === array[array.length - 2]) {
      this.clearData()
    } else {
      sessionStorage.setItem(this.lastVisitedUrlsKey, JSON.stringify(array))
    }
  }

  clearData () {
    sessionStorage.removeItem(this.lastClickedItemHrefKey)
    sessionStorage.removeItem(this.lastVisitedUrlsKey)
    this.lastClickedItemHref = null
    this.lastVisitedUrls = null
  }

  urlToPathName (url) {
    const object = new URL(url)
    return object.pathname
  }
}

/* eslint-disable */
// iOS Safari fix to ensure scroll position is restored on page reload after pressing back button.
;(function () {
  window.onpageshow = function (event) {
    if (event.persisted) {
      new CollectionScrollPosition()
    }
  }
})()

document.addEventListener('DOMContentLoaded', () => {
  new CollectionScrollPosition()
})
/* eslint-enable */
